import { Navigate, Route, Routes } from 'react-router-dom';
import { Loading } from '../components/Atoms/Loading/Loading';
import { AppRoutes } from './App.routes';
import Health from '../pages/Health';
import AppProviders from './App.providers';
import { useGA } from './analytics/useGA';
import { useRUM } from './analytics/useRUM';
import { useAuth } from '../features/auth/providers/AuthProvider';
import Dashboard from '../pages/Dashboard/Dashboard';
import { DashboardContainer, StyledContainer, StyledInnerContainer } from '../app/App.styles';

const RequireAuth = ({ children }: { children: React.ReactElement }) => {
  const { isAuthenticated, ready } = useAuth();

  if (!ready) return <Loading />;
  if (!isAuthenticated) return <Navigate to={AppRoutes.UNAUTHORIZED} replace />;

  return children;
};

const ContainerWrapper = (props: React.PropsWithChildren<{ children: React.ReactNode }>) => (
  <StyledContainer>
    <StyledInnerContainer>{props.children}</StyledInnerContainer>
  </StyledContainer>
);

const App = () => {
  const { trackPageView: pageViewGA } = useGA();
  const { trackPageView: pageViewRum } = useRUM();

  // //Page trackers
  pageViewGA();
  pageViewRum();
  return (
    <AppProviders>
      <ContainerWrapper>
        <Routes>
          <Route path={AppRoutes.HEALTH} element={<Health />} />
          <Route
            path={AppRoutes.UNAUTHORIZED}
            element={
              <>
                <h1>401 - Unauthorized</h1>
                <p>Sorry, you don't have access to this page.</p>
              </>
            }
          />
          <Route
            path={AppRoutes.DASHBOARD}
            element={
              <RequireAuth>
                <DashboardContainer>
                  <Dashboard />
                </DashboardContainer>
              </RequireAuth>
            }
          />
          <Route
            path={AppRoutes.NOT_FOUND}
            element={
              <>
                <h1>404 - Not Found</h1>
                <p>The page you are looking for does not exist.</p>
              </>
            }
          />
          <Route path='/*' element={<Navigate to={AppRoutes.NOT_FOUND} replace />} />
        </Routes>
      </ContainerWrapper>
    </AppProviders>
  );
};

export default App;
